import { External } from "components/icons/generated";
import TableCellLink from "ds/components/Table/Row/CellLink";

import StackPullRequestsTableGroupCell from "../../GroupCell";
import { StackPullRequestsTablePullRequestCellProps } from "../types";

const StackPullRequestsTablePullRequestPrCell = ({
  item: pullRequest,
  ...cellProps
}: StackPullRequestsTablePullRequestCellProps) => {
  return (
    <StackPullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <TableCellLink variant="primary" target="_blank" endIcon={External} href={pullRequest.url}>
        {`#${pullRequest.id}`}
      </TableCellLink>
    </StackPullRequestsTableGroupCell>
  );
};

export default StackPullRequestsTablePullRequestPrCell;
